export default __webpack_public_path__ + "static/media/The Jackdaw's Tithe.f0cc6ef0.jpg";